/* import __COLOCATED_TEMPLATE__ from './date-range-filter.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();